<div class="error-counter-container">
  <!-- <ng-container *ngIf="counterError > 0;else noErrorLabel">
    <span>
      {{errorLabel}}
    </span>
  </ng-container>
  <ng-template #noErrorLabel>
    <span>
      {{ 'error-counter.no-error' | translate}}
    </span>
  </ng-template> -->
  <!-- <button mat-raised-button color="primary"
      [matBadge]="counterError" matBadgeColor="accent">
      {{errorLabel}}
  </button> -->
  <button #menuErrorButton mat-mini-fab color="primary" type="button"
    [matBadge]="(counterTonnageError + counterTollError) > 0 ? (counterTonnageError + counterTollError) : null"
    [matBadgeColor]="(counterTonnageError + counterTollError) == 0 ? 'accent' : 'warn'"
    [matTooltip]="(counterTonnageError + counterTollError) > 0 ? errorLabel :'error-counter.no-error' | translate"
    [matMenuTriggerFor]="menuError" (click)="onErrorClick($event)">
    <mat-icon *ngIf="(counterTonnageError + counterTollError) > 0">error</mat-icon>
    <mat-icon *ngIf="(counterTonnageError + counterTollError) == 0">check</mat-icon>
  </button>
  <mat-menu #menuError>
    <button *ngIf="(counterTonnageError > 0) && (counterTollError > 0)" mat-menu-item (click)="goToTonnageError()">{{'error-counter.tonnage-error' | translate : {counterTonnageError:counterTonnageError} }}</button>
    <button *ngIf="(counterTonnageError > 0) && (counterTollError > 0)" mat-menu-item (click)="goToTollError()">{{'error-counter.toll-error' | translate : {counterTollError:counterTollError} }}</button>
  </mat-menu>
</div>